// import { useState, useMemo, useEffect } from "react";
// import { FaPlay, FaSquare } from "react-icons/fa";
// import {
//   Modal,
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import API_URL from "../Config";
// import axiosInstance from "../axiosinstance";
// import "./EquipmentExecutionTable.css";

// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 420,
//   bgcolor: "background.paper",
//   borderRadius: "8px",
//   boxShadow: 24,
//   p: 3,
// };

// const EquipmentExecutionTable = ({
//   processSteps = [],
//   dependencyMap = {},
//   equipmentId,
// }) => {
//   /* ---------------- STATE ---------------- */
//   const [nextProcess, setNextProcess] = useState(null);

//   const [modal, setModal] = useState({
//     open: false,
//     action: null, // "Start" | "End"
//     remark: "",
//     loading: false,
//   });

//   const [notification, setNotification] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   /* ---------------- STEPS ---------------- */
//   const steps = useMemo(() => {
//     return processSteps.map((step, index) => {
//       const dep = dependencyMap[step.process_id_from_excel] || {};
//       return {
//         id: step.process_id_from_excel,
//         stepNo: index + 1,
//         name: step.process_name,
//         duration: step.durations_eta
//           ? `${step.durations_eta} hrs`
//           : "-",
//         predecessors: dep.predecessors || [],
//         relation: dep.relation || "",
//       };
//     });
//   }, [processSteps, dependencyMap]);

//   /* ---------------- HELPERS ---------------- */
//   const showNotification = (message, severity = "success") => {
//     setNotification({ open: true, message, severity });
//   };

//   const openModal = (action) => {
//     setModal({ open: true, action, remark: "", loading: false });
//   };

//   const closeModal = () => {
//     if (modal.loading) return;
//     setModal({ open: false, action: null, remark: "", loading: false });
//   };

//   /* ---------------- STEP 1: FETCH NEXT PROCESS ---------------- */
//   const fetchNextProcess = async () => {
//     try {
//       const res = await axiosInstance.get(
//         `${API_URL}/api/next_process/${equipmentId}`
//       );

//       console.log("NEXT PROCESS RESPONSE:", res.data);

//       // ✅ CORRECT KEY FROM BACKEND
//       const process = res.data?.next_processes?.[0] || null;
//       setNextProcess(process);
//     } catch (err) {
//       console.error("Failed to fetch next process:", err);
//     }
//   };

//   /* ---------------- ON PAGE LOAD ---------------- */
//   useEffect(() => {
//     if (equipmentId) fetchNextProcess();
//   }, [equipmentId]);

//   /* ---------------- STEP 2: START / END PROCESS ---------------- */
//   const submitProcessAction = async () => {
//     if (!modal.remark.trim()) {
//       showNotification("Please enter a remark", "warning");
//       return;
//     }

//     try {
//       setModal((p) => ({ ...p, loading: true }));

//       const processId = nextProcess?.process_id;
//       if (!processId) {
//         showNotification("No process available", "error");
//         closeModal();
//         return;
//       }

//       await axiosInstance.post(
//         `${API_URL}/api/process/${processId}`,
//         {
//           action: modal.action,
//           remark: modal.remark,
//         }
//       );

//       showNotification(
//         modal.action === "Start"
//           ? "Process started successfully"
//           : "Process completed successfully"
//       );

//       closeModal();
//       fetchNextProcess(); // ✅ refresh backend truth
//     } catch (err) {
//       showNotification(
//         err.response?.data?.message || "Action failed",
//         "error"
//       );
//       setModal((p) => ({ ...p, loading: false }));
//     }
//   };

//   /* ---------------- RENDER ---------------- */
//   return (
//     <div className="execution-card">
//       <h3 className="card-title">Equipment Execution Control</h3>

//       <div className="execution-table-wrapper">
//         <table className="execution-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Step Name</th>
//               <th>Duration</th>
//               <th>Dependency</th>
//               <th>Actual Start</th>
//               <th>Actual End</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {steps.map((step) => {
//               const isInProgress =
//                 nextProcess?.status === "In Progress";

//               // ✅ CORRECT BUTTON LOGIC
//               const canStart =
//                 nextProcess?.action === "Start" && !isInProgress;

//               const canEnd = isInProgress;

//               return (
//                 <tr key={step.id}>
//                   <td>{step.stepNo}</td>
//                   <td className="truncate">{step.name}</td>
//                   <td>{step.duration}</td>
//                   <td className="dependency">
//                     {!step.predecessors.length
//                       ? "No dependencies"
//                       : `${step.relation} on Step ${step.predecessors.join(
//                           ", "
//                         )}`}
//                   </td>

//                   <td>
//                     {isInProgress && nextProcess?.actual_eta
//                       ? new Date(
//                           nextProcess.actual_eta
//                         ).toLocaleString("en-GB")
//                       : "-"}
//                   </td>
//                   <td>-</td>

//                   <td>
//                     <span
//                       className={`status ${
//                         isInProgress
//                           ? "in-progress"
//                           : "not-started"
//                       }`}
//                     >
//                       {isInProgress ? "In Progress" : "Not Started"}
//                     </span>
//                   </td>

//                   <td className="actions">
//                     <button
//                       disabled={!canStart}
//                       onClick={() => openModal("Start")}
//                     >
//                       <FaPlay /> Start
//                     </button>

//                     <button
//                       disabled={!canEnd}
//                       onClick={() => openModal("End")}
//                     >
//                       <FaSquare /> End
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       {/* ---------------- MODAL ---------------- */}
//       <Modal open={modal.open} onClose={closeModal}>
//         <Box sx={modalStyle}>
//           <Typography variant="h6" mb={2}>
//             {modal.action} Process
//           </Typography>

//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             label="Remark"
//             value={modal.remark}
//             onChange={(e) =>
//               setModal((p) => ({ ...p, remark: e.target.value }))
//             }
//           />

//           <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
//             <Button onClick={closeModal}>Cancel</Button>
//             <Button
//               variant="contained"
//               onClick={submitProcessAction}
//               disabled={modal.loading}
//             >
//               Submit
//             </Button>
//           </Box>
//         </Box>
//       </Modal>

//       {/* ---------------- NOTIFICATION ---------------- */}
//       <Snackbar
//         open={notification.open}
//         autoHideDuration={6000}
//         onClose={() =>
//           setNotification((p) => ({ ...p, open: false }))
//         }
//       >
//         <Alert severity={notification.severity}>
//           {notification.message}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default EquipmentExecutionTable;

import { useState, useMemo, useEffect, useRef } from "react";
import { FaPlay, FaSquare } from "react-icons/fa";
import { IoIosEye } from "react-icons/io";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  Tooltip,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API_URL from "../Config";
import axiosInstance from "../axiosinstance";
import { BiErrorCircle } from "react-icons/bi";
import { LiaUserEditSolid } from "react-icons/lia";
import { IoPlayCircleOutline } from "react-icons/io5";
import { FiClock } from "react-icons/fi";
import { LuGlobe } from "react-icons/lu";
import { IoMdAttach } from "react-icons/io";
import { FiSearch, FiRefreshCw } from "react-icons/fi";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import DownloadIcon from "@mui/icons-material/Download";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import "./EquipmentExecutionTable.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 3,
};

const processActionModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "calc(100vw - 28px)", sm: 500 },
  maxWidth: "500px",
  bgcolor: "#ffffff",
  borderRadius: "16px",
  border: "1px solid #f1d6d6",
  boxShadow: "0 18px 50px rgba(91, 33, 33, 0.16)",
  p: { xs: 2.25, sm: 3 },
};

const processActionInputSx = {
  mb: 1.8,
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    minHeight: 48,
    "& fieldset": { borderColor: "#e6c7c7" },
    "&:hover fieldset": { borderColor: "#d9a3a3" },
    "&.Mui-focused fieldset": { borderColor: "#bf4b4b", borderWidth: "1px" },
  },
  "& .MuiInputLabel-root": {
    color: "#8a5a5a",
    fontWeight: 500,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#9f2f2f",
  },
};

const processActionTextAreaSx = {
  ...processActionInputSx,
  mb: 2,
  "& .MuiOutlinedInput-root": {
    ...processActionInputSx["& .MuiOutlinedInput-root"],
    minHeight: 110,
    alignItems: "flex-start",
    paddingTop: "6px",
  },
};

const processActionUploadButtonSx = {
  mb: 0.5,
  height: 46,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  border: "1px dashed #d7aaaa",
  color: "#922f2f",
  backgroundColor: "#fff9f9",
  justifyContent: "flex-start",
  px: 1.6,
  "&:hover": {
    borderColor: "#c87f7f",
    backgroundColor: "#fff3f3",
  },
};

const adminNoteModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "calc(100vw - 28px)", sm: 560 },
  maxWidth: "560px",
  bgcolor: "#ffffff",
  borderRadius: "16px",
  border: "1px solid #f1d6d6",
  boxShadow: "0 18px 50px rgba(91, 33, 33, 0.16)",
  p: { xs: 2.25, sm: 3 },
};

const adminNoteInputSx = {
  mt: 2,
  mb: 1.5,
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#e6c7c7" },
    "&:hover fieldset": { borderColor: "#d9a3a3" },
    "&.Mui-focused fieldset": { borderColor: "#bf4b4b", borderWidth: "1px" },
  },
  "& .MuiInputLabel-root": {
    color: "#8a5a5a",
    fontWeight: 500,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#9f2f2f",
  },
};

const isBypassedValue = (value) =>
  value === true || value === 1 || String(value).trim().toLowerCase() === "true";

export const canBypassProcess = (step) =>
  step?.can_bypass === true && !isBypassedValue(step?.is_bypassed);

const formatToDateTimeLocalValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const parseDateTimeLocalValue = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const parseDateTimeParts = (value) => {
  if (!value) return null;
  const match = String(value).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/,
  );
  if (!match) return null;
  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
    hour: Number(match[4]),
    minute: Number(match[5]),
  };
};

const formatDateTimeFromParts = (parts) => {
  if (!parts) return "";
  const { year, month, day, hour, minute } = parts;
  return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")} ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

const addMinutesToDateTimeParts = (parts, minutesToAdd) => {
  if (!parts || !Number.isFinite(minutesToAdd)) return null;
  const utcMs =
    Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute) +
    minutesToAdd * 60 * 1000;
  const dt = new Date(utcMs);
  return {
    year: dt.getUTCFullYear(),
    month: dt.getUTCMonth() + 1,
    day: dt.getUTCDate(),
    hour: dt.getUTCHours(),
    minute: dt.getUTCMinutes(),
  };
};

const formatDateTimeInTimezone = (inputValue, timezone) => {
  if (!inputValue) return "N/A";
  const date = new Date(inputValue);
  if (Number.isNaN(date.getTime())) return "N/A";

  if (!timezone) {
    return formatDateTimeFromParts({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
    });
  }

  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(date);

    const val = (type) => parts.find((p) => p.type === type)?.value || "";
    const day = val("day");
    const month = val("month");
    const year = val("year");
    const hour = val("hour");
    const minute = val("minute");

    if (!year || !month || !day || !hour || !minute) return "N/A";
    return `${year}-${month}-${day} ${hour}:${minute}`;
  } catch (error) {
    return "N/A";
  }
};

const parseDurationMinutes = (processStep) => {
  if (!processStep) return null;

  const rawDuration = processStep?.durations_eta;
  if (rawDuration === null || rawDuration === undefined || rawDuration === "") {
    return null;
  }

  const durationValue = Number(rawDuration);
  if (!Number.isFinite(durationValue)) return null;

  const unitHint = String(
    processStep?.duration_unit ||
      processStep?.duration_uom ||
      processStep?.duration_type ||
      processStep?.durationUnit ||
      "hours",
  )
    .trim()
    .toLowerCase();

  const isMinutes =
    unitHint.includes("min") ||
    unitHint === "m" ||
    unitHint === "minute" ||
    unitHint === "minutes";

  return isMinutes
    ? Math.round(durationValue)
    : Math.round(durationValue * 60);
};

// Shared, polished tooltip used across the execution table. Replaces MUI's
// cramped default with a clean light card: white background, dark readable
// text, rounded corners, comfortable padding and a soft shadow.
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "#1f2937",
    fontSize: "12px",
    lineHeight: 1.55,
    fontWeight: 500,
    padding: "9px 12px",
    borderRadius: "10px",
    maxWidth: 320,
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.16)",
    border: "1px solid #e2e8f0",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffffff",
    "&::before": {
      border: "1px solid #e2e8f0",
    },
  },
}));

const clampZoom = (value) => Math.min(300, Math.max(25, value));

const FilePreviewModal = ({ preview, onClose, formatUploadedAt }) => {
  const [activeStage, setActiveStage] = useState("end");
  const [zoom, setZoom] = useState(100);
  const [rotation, setRotation] = useState(0);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragRef = useRef(null);

  const files = {
    start: { file: preview.startFile, url: preview.startPreviewUrl },
    end: { file: preview.endFile, url: preview.endPreviewUrl },
  };
  const availableStages = ["start", "end"].filter((stage) => files[stage].file);
  const active = files[activeStage];
  const isPdf = active.file?.file_path?.toLowerCase().endsWith(".pdf");

  const resetView = () => {
    setZoom(100);
    setRotation(0);
    setPosition({ x: 0, y: 0 });
  };

  useEffect(() => {
    if (preview.open) {
      setActiveStage(preview.endFile ? "end" : "start");
      resetView();
    }
  }, [preview.open, preview.startFile, preview.endFile]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!preview.open || availableStages.length < 2) return;
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        setActiveStage((stage) => (stage === "start" ? "end" : "start"));
        resetView();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [preview.open, availableStages.length]);

  const selectStage = (stage) => {
    if (!files[stage].file || stage === activeStage) return;
    setActiveStage(stage);
    resetView();
  };

  const navigate = () => selectStage(activeStage === "start" ? "end" : "start");

  const changeZoom = (nextZoom) => {
    setZoom(clampZoom(nextZoom));
    if (nextZoom <= 100) setPosition({ x: 0, y: 0 });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = active.url;
    link.download = active.file?.file_name || "file";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const iconAction = (label, icon, action, disabled = false) => (
    <StyledTooltip title={label} arrow>
      <span>
        <IconButton
          size="small"
          aria-label={label}
          onClick={action}
          disabled={disabled}
          sx={{ width: 34, height: 34, color: disabled ? "#cbd5e1" : "#6b7280", borderRadius: "50%", "&:hover": { bgcolor: "#f1f5f9", color: "#1f2937" } }}
        >
          {icon}
        </IconButton>
      </span>
    </StyledTooltip>
  );

  return (
    <Modal open={preview.open} onClose={onClose} aria-labelledby="file-preview-title">
      <Box sx={{ position: "absolute", inset: "50% auto auto 50%", transform: "translate(-50%, -50%)", width: { xs: "calc(100vw - 16px)", sm: "90vw" }, height: { xs: "calc(100vh - 16px)", sm: "88vh" }, maxWidth: 1500, bgcolor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: { xs: 2, sm: 3 }, boxShadow: "0 24px 64px rgba(15,23,42,.18)", overflow: "hidden", display: "grid", gridTemplateRows: "auto auto minmax(0, 1fr) auto", outline: 0 }}>
        <Box component="header" sx={{ position: "sticky", top: 0, zIndex: 3, minHeight: 68, px: { xs: 2, sm: 3 }, py: 1.5, display: "flex", alignItems: "center", gap: 2, bgcolor: "#ffffff", borderBottom: "1px solid #e5e7eb", boxShadow: "0 1px 2px rgba(15,23,42,.04)" }}>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography id="file-preview-title" variant="h6" sx={{ color: "#1a1a1a", fontWeight: 700, lineHeight: 1.2 }}>File Preview</Typography>
            <Typography noWrap sx={{ mt: 0.25, color: "#6b7280", fontSize: 13 }}>{active.file?.file_name || "No file uploaded"}</Typography>
          </Box>
          {active.file && <Box component="span" sx={{ px: 1.25, py: 0.4, borderRadius: 999, bgcolor: "#f3f4f6", border: "1px solid #e5e7eb", color: "#4b5563", fontSize: 12, fontWeight: 700, textTransform: "capitalize" }}>{activeStage}</Box>}
          <StyledTooltip title="Close preview" arrow><IconButton aria-label="Close file preview" onClick={onClose} sx={{ color: "#6b7280", border: "1px solid #e5e7eb", "&:hover": { color: "#111827", bgcolor: "#f3f4f6" } }}><CloseIcon fontSize="small" /></IconButton></StyledTooltip>
        </Box>

        <Box sx={{ px: { xs: 2, sm: 3 }, py: 1.25, display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 1.5, bgcolor: "white", borderBottom: "1px solid #e5e7eb" }}>
          <Box role="tablist" aria-label="Available files" sx={{ display: "flex", alignItems: "center", minHeight: 38 }}>
            {["start", "end"].map((stage) => {
              const enabled = Boolean(files[stage].file);
              const selected = enabled && activeStage === stage;
              return <Box key={stage} sx={{ display: "flex", alignItems: "center" }}>
                {stage === "end" && <Box aria-hidden="true" sx={{ width: { xs: 24, sm: 42 }, height: 2, bgcolor: files.start.file && files.end.file ? "#94a3b8" : "#d1d5db" }} />}
                <Button role="tab" aria-selected={selected} disabled={!enabled} onClick={() => selectStage(stage)} size="small" sx={{ minHeight: 34, px: 1, color: selected ? "#111827" : "#6b7280", textTransform: "none", fontWeight: selected ? 700 : 600, "&:hover": { bgcolor: "#f3f4f6" }, "&.Mui-disabled": { color: "#9ca3af" } }}>
                  <Box component="span" sx={{ width: 12, height: 12, mr: 0.75, borderRadius: "50%", bgcolor: selected ? "#374151" : "#fff", border: `2px solid ${enabled ? "#6b7280" : "#d1d5db"}`, boxShadow: selected ? "inset 0 0 0 2px #fff" : "none" }} />
                  {stage === "start" ? "Start" : "End"}{!enabled && <Box component="span" sx={{ display: { xs: "none", md: "inline" }, ml: 0.6, fontSize: 10, fontWeight: 500 }}>(not uploaded)</Box>}
                </Button>
              </Box>;
            })}
          </Box>
          <Box role="toolbar" aria-label="File preview controls" sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
            {iconAction("Zoom out", <ZoomOutIcon fontSize="small" />, () => changeZoom(zoom - 25), isPdf || zoom <= 25)}
            <Typography aria-live="polite" sx={{ width: 48, textAlign: "center", fontSize: 12, fontWeight: 700, color: "#334155" }}>{zoom}%</Typography>
            {iconAction("Zoom in", <ZoomInIcon fontSize="small" />, () => changeZoom(zoom + 25), isPdf || zoom >= 300)}
            {iconAction("Fit to screen", <FitScreenIcon fontSize="small" />, () => { setZoom(100); setPosition({ x: 0, y: 0 }); }, isPdf)}
            {iconAction("Reset view", <RestartAltIcon fontSize="small" />, resetView, isPdf)}
            <Box aria-hidden="true" sx={{ width: 1, height: 24, mx: 0.75, bgcolor: "#e5e7eb" }} />
            {iconAction("Rotate left", <RotateLeftIcon fontSize="small" />, () => setRotation((value) => value - 90), isPdf)}
            {iconAction("Rotate right", <RotateRightIcon fontSize="small" />, () => setRotation((value) => value + 90), isPdf)}
            <Box aria-hidden="true" sx={{ width: 1, height: 24, mx: 0.75, bgcolor: "#e5e7eb" }} />
            {iconAction("Download", <DownloadIcon fontSize="small" />, handleDownload, !active.url)}
            {iconAction("Open in new tab", <OpenInNewIcon fontSize="small" />, () => window.open(active.url, "_blank", "noopener,noreferrer"), !active.url)}
          </Box>
        </Box>

        <Box onWheel={(event) => { if (!isPdf) { event.preventDefault(); changeZoom(zoom + (event.deltaY < 0 ? 10 : -10)); } }} onPointerDown={(event) => { if (!isPdf && zoom > 100) { event.currentTarget.setPointerCapture(event.pointerId); dragRef.current = { x: event.clientX - position.x, y: event.clientY - position.y }; } }} onPointerMove={(event) => { if (dragRef.current) setPosition({ x: event.clientX - dragRef.current.x, y: event.clientY - dragRef.current.y }); }} onPointerUp={(event) => { dragRef.current = null; if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId); }} sx={{ position: "relative", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", p: { xs: 2, sm: 3 }, bgcolor: "#f3f4f6", cursor: !isPdf && zoom > 100 ? (dragRef.current ? "grabbing" : "grab") : "default", touchAction: "none", userSelect: "none" }}>
          {active.url && (isPdf ? <iframe src={active.url} width="100%" height="100%" style={{ border: "1px solid #d1d5db", borderRadius: 4, background: "white", boxShadow: "0 8px 24px rgba(15,23,42,.12)" }} title={`${activeStage} file PDF preview`} /> : <img draggable={false} src={active.url} alt={active.file?.file_name || `${activeStage} file`} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", background: "white", border: "1px solid #d1d5db", borderRadius: 4, boxShadow: "0 8px 24px rgba(15,23,42,.12)", transform: `translate(${position.x}px, ${position.y}px) scale(${zoom / 100}) rotate(${rotation}deg)`, transition: dragRef.current ? "none" : "transform 120ms ease", transformOrigin: "center" }} />)}
          {availableStages.length > 1 && <><IconButton aria-label="Previous file" onClick={navigate} sx={{ position: "absolute", left: { xs: 8, sm: 16 }, color: "#4b5563", bgcolor: "rgba(255,255,255,.94)", border: "1px solid #d1d5db", boxShadow: "0 2px 8px rgba(15,23,42,.12)", "&:hover": { bgcolor: "#fff", color: "#111827" } }}><ChevronLeftIcon /></IconButton><IconButton aria-label="Next file" onClick={navigate} sx={{ position: "absolute", right: { xs: 8, sm: 16 }, color: "#4b5563", bgcolor: "rgba(255,255,255,.94)", border: "1px solid #d1d5db", boxShadow: "0 2px 8px rgba(15,23,42,.12)", "&:hover": { bgcolor: "#fff", color: "#111827" } }}><ChevronRightIcon /></IconButton></>}
        </Box>

        <Box component="footer" sx={{ px: { xs: 2, sm: 3 }, py: 1.5, display: "flex", flexWrap: "wrap", gap: { xs: 2, sm: 5 }, bgcolor: "#f9fafb", borderTop: "1px solid #e5e7eb" }}>
          {[['Stage', activeStage, <FlagOutlinedIcon />], ['Uploaded', formatUploadedAt(active.file?.uploaded_at), <CalendarTodayOutlinedIcon />], [activeStage === 'end' ? 'Ended by' : 'Uploaded by', activeStage === 'end' ? preview.ended_by : preview.started_by, <PersonOutlineIcon />]].map(([label, value, icon]) => <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 1 }}><Box sx={{ display: "flex", color: "#9ca3af", "& svg": { fontSize: 18 } }}>{icon}</Box><Box><Typography sx={{ color: "#6b7280", fontSize: 12, lineHeight: 1.2 }}>{label}</Typography><Typography sx={{ mt: 0.25, color: "#1f2937", fontSize: 14, fontWeight: 700, lineHeight: 1.25, textTransform: label === 'Stage' ? 'capitalize' : 'none' }}>{value || "—"}</Typography></Box></Box>)}
        </Box>
      </Box>
    </Modal>
  );
};

const EquipmentExecutionTable = ({
  processSteps = [],
  addAdminNoteToStep,
  onProcessBypassed,
  equipmentTimezone = "",
  dependencyMap = {},
  equipmentId,
  isEquipmentOnHold = false,
  equipmentHoldReason = "",
  canEditProcessTime = false,
  refreshEquipmentDetails,
  selectedProcessId,
  onDependencyNavigate,
  realtimeProcessUpdate,
  realtimeUpdateSignal = 0,
  tableLoading = false,
  searchQuery = "",
  onSearchChange,
  onClearSearch,
}) => {
  const [adminNotes, setAdminNotes] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const [nextProcesses, setNextProcesses] = useState([]);
  const [optimisticStepUpdates, setOptimisticStepUpdates] = useState({});
  const [currentProcessId, setCurrentProcessId] = useState(null);
  const [filePreview, setFilePreview] = useState({
    open: false,
    stepName: "",
    stepCode: "",
    startFile: null,
    endFile: null,
    startPreviewUrl: null,
    endPreviewUrl: null,
    started_by: null,
    ended_by: null,
  });

  const [modal, setModal] = useState({
    open: false,
    action: null,
    processId: null,
    processName: "",
    file: null,
    time: "",
    loading: false,
  });
  const [bypassModal, setBypassModal] = useState({
    open: false,
    processId: null,
    processName: "",
    reason: "",
    loading: false,
  });
  const [showSlowSubmissionNotice, setShowSlowSubmissionNotice] = useState(false);
  const remarkRef = useRef(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminNoteModal, setAdminNoteModal] = useState({
    open: false,
    remark: "",
    loading: false,
    processId: null,
     notes: [],
  });
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const realtimeNextProcessTimerRef = useRef(null);
  const dependencyHighlightTimeoutRef = useRef(null);
  const [dependencyHighlightedProcessId, setDependencyHighlightedProcessId] =
    useState(null);
  const holdActionMessage = equipmentHoldReason
    ? `Equipment is on hold: ${equipmentHoldReason}`
    : "Equipment is on hold";

  useEffect(() => {
    if (!modal.loading) {
      setShowSlowSubmissionNotice(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setShowSlowSubmissionNotice(true);
    }, 3000);

    return () => window.clearTimeout(timer);
  }, [modal.loading]);
  const selectedModalStep = useMemo(
    () =>
      processSteps.find(
        (step) => String(step?.process_id) === String(modal?.processId),
      ) || null,
    [processSteps, modal?.processId],
  );

  const tentativeEndTimeDisplay = useMemo(() => {
    if (modal?.action !== "Start") return "";

    const startParts = parseDateTimeParts(modal?.time);
    if (!startParts) return "N/A";

    const durationMinutes = parseDurationMinutes(selectedModalStep);
    if (durationMinutes === null) return "N/A";

    const endParts = addMinutesToDateTimeParts(startParts, durationMinutes);
    if (!endParts) return "N/A";
    return formatDateTimeFromParts(endParts);
  }, [modal?.action, modal?.time, selectedModalStep]);

  const durationDisplay = useMemo(() => {
    if (modal?.action !== "Start") return "";
    const rawDuration = selectedModalStep?.durations_eta;
    if (rawDuration === null || rawDuration === undefined || rawDuration === "") {
      return "N/A";
    }

    const unitHint = String(
      selectedModalStep?.duration_unit ||
        selectedModalStep?.duration_uom ||
        selectedModalStep?.duration_type ||
        selectedModalStep?.durationUnit ||
        "hours",
    )
      .trim()
      .toLowerCase();

    const isMinutes =
      unitHint.includes("min") ||
      unitHint === "m" ||
      unitHint === "minute" ||
      unitHint === "minutes";

    const numericDuration = Number(rawDuration);
    if (!Number.isFinite(numericDuration)) return "N/A";

    if (isMinutes) {
      return `${numericDuration} ${numericDuration === 1 ? "minute" : "minutes"}`;
    }
    return `${numericDuration} ${numericDuration === 1 ? "hour" : "hours"}`;
  }, [modal?.action, selectedModalStep]);

  const modalTimezone = useMemo(() => {
    const possibleTz =
      selectedModalStep?.project_tz ||
      selectedModalStep?.project_timezone ||
      selectedModalStep?.timezone ||
      selectedModalStep?.tz ||
      equipmentTimezone ||
      processSteps?.[0]?.project_tz ||
      processSteps?.[0]?.project_timezone ||
      processSteps?.[0]?.timezone ||
      processSteps?.[0]?.tz ||
      "";
    return String(possibleTz || "").trim();
  }, [selectedModalStep, processSteps, equipmentTimezone]);

  const timezoneDisplay = useMemo(() => {
    if (!modalTimezone) return "N/A";
    try {

      
      const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: modalTimezone,
        timeZoneName: "shortOffset",
      }).formatToParts(new Date());
      const offsetPart = parts.find((p) => p.type === "timeZoneName")?.value || "";
      const normalizedOffset = offsetPart.replace("GMT", "GMT");
      return `${modalTimezone}${normalizedOffset ? ` (${normalizedOffset})` : ""}`;
    } catch (error) {
      return modalTimezone;
    }
  }, [modalTimezone]);

  const startedAtDisplay = useMemo(() => {
    if (modal?.action !== "End") return "";
    return formatDateTimeInTimezone(selectedModalStep?.actual_start, modalTimezone);


    
  }, [modal?.action, selectedModalStep, modalTimezone]);

  useEffect(() => {
    if (!modal?.open) return;
    console.log("[TEMP][Start/End Modal] selected process object:", selectedModalStep);
    console.log("[TEMP][Start/End Modal] resolved modalTimezone:", modalTimezone);
    console.log("[TEMP][Start/End Modal] timezone display output:", timezoneDisplay);
  }, [modal?.open, selectedModalStep, modalTimezone, timezoneDisplay]);

  
  useEffect(() => {
      const userRole = (localStorage.getItem("role_name") || "")
        .trim()
        .toLowerCase();
      setIsAdmin(userRole === "admin");
    }, []);
  useEffect(() => {
    // Keep a successful local bypass visible when an older process-list API
    // response does not yet include bypass metadata. Normal start/end updates
    // continue to be cleared on the next authoritative refresh.
    setOptimisticStepUpdates((previous) => {
      const retained = Object.fromEntries(
        Object.entries(previous).filter(([processId, update]) => {
          if (!update?.is_bypassed) return false;
          const serverStep = processSteps.find(
            (step) => String(step?.process_id) === String(processId),
          );
          return (
            serverStep &&
            !Object.prototype.hasOwnProperty.call(serverStep, "is_bypassed")
          );
        }),
      );

      return Object.keys(retained).length === Object.keys(previous).length
        ? previous
        : retained;
    });
  }, [processSteps]);
  /* ---------------- STEPS MAPPING WITH UUID ---------------- */
  // Optional client-side sort by process code. `null` keeps the default
  // execution order (planned start) that the backend returns.
  const [processCodeSort, setProcessCodeSort] = useState(null); // null | "asc" | "desc"

  const toggleProcessCodeSort = () =>
    setProcessCodeSort((prev) =>
      prev === "asc" ? "desc" : prev === "desc" ? null : "asc",
    );

  const steps = useMemo(() => {

    return processSteps.map((step, index) => {
      const optimisticUpdate = optimisticStepUpdates[step.process_id] || null;
      // ✅ CRITICAL: dependency_map keys are UUIDs (process_id), not Excel IDs
      const dep = dependencyMap[step.process_id] || {};

      // ✅ Convert predecessor UUIDs to step numbers for display
      const predecessorStepNos = [];
      let lagInfo = null;

      if (dep.predecessors && dep.predecessors.length > 0) {
        dep.predecessors.forEach((predUuid) => {
          // Find the step with this UUID
          const predIndex = processSteps.findIndex(
            (s) => s.process_id === predUuid,
          );
          if (predIndex !== -1) {
            predecessorStepNos.push(predIndex + 1);
          }
        });
      }

      // ✅ Get lag info from dependencies array in process_steps
      if (step.dependencies && step.dependencies.length > 0) {
        const firstDep = step.dependencies[0];
        if (firstDep.lag && firstDep.unit) {
          lagInfo = {
            lag: firstDep.lag,
            unit: firstDep.unit,
            relation: firstDep.relation,
          };
        }
      }

      // ✅ Create detailed tooltip for dependencies
      let dependencyTooltip = "";
      if (step.dependencies && step.dependencies.length > 0) {
        dependencyTooltip = step.dependencies
          .map((dep, idx) => {
            const parts = [];
            parts.push(`Dependency's:`);
            parts.push(`  Name: ${dep.depends_on.name}`);
            parts.push(`  Code: ${dep.depends_on.code}`);
            parts.push(`  Relation: ${dep.relation}`);
            if (dep.lag) {
              parts.push(`  Lag: ${dep.lag}`);
            }
            if (dep.unit) {
              parts.push(`  Unit: ${dep.unit}`);
            }
            // if (dep.depends_on.equipment_id) {
            //   parts.push(`  Equipment ID: ${dep.depends_on.equipment_id}`);
            // }
            return parts.join("\n");
          })
          .join("\n\n");
      }

      return {
        id: step.process_id,
        stepNo: index + 1,
        name: step.process_name,
        duration: step.durations_eta ? `${step.durations_eta} hrs` : "-",
        duration_analysis:
          optimisticUpdate?.duration_analysis ?? step.duration_analysis ?? null,
        predecessorStepNos: predecessorStepNos,
        predecessorCount: predecessorStepNos.length,
        relation: dep.relation || "",
        lagInfo: lagInfo,
        dependencyTooltip: dependencyTooltip,
        backendStatus: optimisticUpdate?.backendStatus ?? step.status,
        is_bypassed:
          optimisticUpdate?.is_bypassed ?? isBypassedValue(step.is_bypassed),
        can_bypass:
          optimisticUpdate?.is_bypassed ? false : step.can_bypass === true,
        bypassed_by: optimisticUpdate?.bypassed_by ?? step.bypassed_by ?? null,
        bypassed_by_name:
          optimisticUpdate?.bypassed_by_name ?? step.bypassed_by_name ?? null,
        bypassed_at: optimisticUpdate?.bypassed_at ?? step.bypassed_at ?? null,
        bypass_reason:
          optimisticUpdate?.bypass_reason ?? step.bypass_reason ?? null,
        planned_start: step.start_eta,
        planned_end: step.finish_eta,
        actual_start: optimisticUpdate?.actual_start ?? step.actual_start,
        actual_end: optimisticUpdate?.actual_end ?? step.actual_end,
        process_code: step.process_code,
        is_milestone: step.is_milestone ?? false,
        files: step.files || [],
        started_by: optimisticUpdate?.started_by ?? step.started_by ?? null,
        ended_by: optimisticUpdate?.ended_by ?? step.ended_by ?? null,
        start_remark: step.start_remark ?? null,
        end_remark: step.end_remark ?? null,
        admin_notes: Array.isArray(step.admin_notes) ? step.admin_notes : [],
        blocked_reason: step.blocked_reason || null,
        departments: Array.isArray(step.departments) ? step.departments : [],
      };
    });
  }, [processSteps, dependencyMap, optimisticStepUpdates]);

  // Display order: default (execution order) unless the user opts into sorting
  // by process code. Sorting only reorders rows for display — `stepNo` and the
  // dependency step references stay tied to the original execution order.
  const displayedSteps = useMemo(() => {
    if (!processCodeSort) return steps;
    const sorted = [...steps].sort((a, b) =>
      String(a.process_code || "").localeCompare(
        String(b.process_code || ""),
        undefined,
        { numeric: true, sensitivity: "base" },
      ),
    );
    if (processCodeSort === "desc") sorted.reverse();
    return sorted;
  }, [steps, processCodeSort]);

  const processCodeToIdMap = useMemo(() => {
    const map = new Map();
    processSteps.forEach((step) => {
      const code = String(step?.process_code || "").trim();
      if (code) {
        map.set(code, String(step?.process_id || ""));
      }
    });
    return map;
  }, [processSteps]);

  /* ---------------- HELPERS ---------------- */
  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };

  const handleDependencyRedirect = (dependency) => {
    const dependsOn = dependency?.depends_on || {};
    const targetProcessCode = String(dependsOn?.code || "").trim();
    const directProcessId = String(
      dependsOn?.process_id || dependsOn?.id || "",
    ).trim();
    const resolvedProcessId =
      directProcessId || processCodeToIdMap.get(targetProcessCode) || "";
    const targetEquipmentId = String(
      dependsOn?.equipment_id || dependsOn?.equipmentId || "",
    ).trim();
    const currentEquipmentId = String(equipmentId || "").trim();

    const scrollAndHighlight = (processId) => {
      const row = document.querySelector(`tr[data-process-id="${processId}"]`);
      if (!row) return false;

      row.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });

      setDependencyHighlightedProcessId(processId);
      if (dependencyHighlightTimeoutRef.current) {
        clearTimeout(dependencyHighlightTimeoutRef.current);
      }
      dependencyHighlightTimeoutRef.current = setTimeout(() => {
        setDependencyHighlightedProcessId(null);
      }, 2600);
      return true;
    };

    if (resolvedProcessId && scrollAndHighlight(resolvedProcessId)) {
      return;
    }

    if (
      targetEquipmentId &&
      targetEquipmentId !== currentEquipmentId &&
      typeof onDependencyNavigate === "function"
    ) {
      onDependencyNavigate(targetEquipmentId, resolvedProcessId || null);
      return;
    }

    showNotification("Dependency target process not found in this context.", "info");
  };

  const renderStatusBadge = (label, tone, extraProps = {}) => (
    <span className={`status status-${tone}`} {...extraProps}>
      <span className="status-dot" aria-hidden="true" />
      <span className="status-label">{label}</span>
    </span>
  );

  const openModal = (processId, processName, action) => {
    const selectedStep = processSteps.find(
      (step) => String(step?.process_id) === String(processId),
    );
    if (selectedStep?.is_milestone && !isAdmin) {
      showNotification("Only an admin can start or end a milestone", "warning");
      return;
    }

    if (isEquipmentOnHold) {
      showNotification(holdActionMessage, "warning");
      return;
    }

    // Resolve the project's timezone for this step (mirrors `modalTimezone`).
    // NOTE: selectedModalStep/modalTimezone are memoized off the *previous*
    // modal.processId, so they are stale here — look the step up fresh by the
    // processId argument and fall back to the equipmentTimezone prop.
    const stepForTz = processSteps.find(
      (step) => String(step?.process_id) === String(processId),
    );
    const tz =
      stepForTz?.project_tz ||
      stepForTz?.project_timezone ||
      stepForTz?.timezone ||
      stepForTz?.tz ||
      equipmentTimezone ||
      Intl.DateTimeFormat().resolvedOptions().timeZone;

    const now = new Date().toLocaleString("sv-SE", {
      timeZone: tz,
      hour12: false,
    }).slice(0, 16).replace(" ", "T");

    setModal({
      open: true,
      action,
      processId,
      processName,
      file: null,
      time: now,
      loading: false,
    });
  };

  const closeModal = () => {
    if (modal.loading) return;
    setModal({
      open: false,
      action: null,
      processId: null,
      processName: "",
      file: null,
      loading: false,
    });
  };

  const openBypassModal = (step) => {
    if (!canBypassProcess(step)) {
      showNotification("This process is not eligible to be bypassed", "warning");
      return;
    }

    setBypassModal({
      open: true,
      processId: step.id,
      processName: step.name,
      reason: "",
      loading: false,
    });
  };

  const closeBypassModal = () => {
    if (bypassModal.loading) return;
    setBypassModal({
      open: false,
      processId: null,
      processName: "",
      reason: "",
      loading: false,
    });
  };

  useEffect(() => {
    if (!isEquipmentOnHold || !modal.open) return;

    // The hold may arrive while a Start/End dialog is already open. Close it
    // immediately so stale actions cannot be submitted from the old state.
    setModal({
      open: false,
      action: null,
      processId: null,
      processName: "",
      file: null,
      time: "",
      loading: false,
    });
    showNotification(holdActionMessage, "warning");
  }, [isEquipmentOnHold, holdActionMessage, modal.open]);

  useEffect(() => {
    return () => {
      if (dependencyHighlightTimeoutRef.current) {
        clearTimeout(dependencyHighlightTimeoutRef.current);
      }
    };
  }, []);
  const closeAdminNoteModal = () => {
    setAdminNoteModal({
      open: false,
      remark: "",
      loading: false,
      processId: null,
      notes: [],
    });
  };
  const submitAdminNote = async () => {
    try {
      setAdminNoteModal((p) => ({ ...p, loading: true }));

      await axiosInstance.post("/api/admin-notes/process", {
        note_content: adminNoteModal.remark,
        process_id: adminNoteModal.processId,
      });
      // ✅ Update processSteps locally
    addAdminNoteToStep(adminNoteModal.processId, adminNoteModal.remark);


      closeAdminNoteModal();
    } catch (error) {
      console.error("Admin note error:", error);
    } finally {
      setAdminNoteModal((p) => ({ ...p, loading: false }));
    }
  };
  /* ---------------- FETCH NEXT PROCESS (SINGLE) ---------------- */
  const fetchNextProcesses = async () => {
    if (isEquipmentOnHold) {
      setNextProcesses({});
      setCurrentProcessId(null);
      return;
    }

    try {
      const res = await axiosInstance.get(
        `${API_URL}/api/next_process/${equipmentId}`,
      );

      console.log("✅ API Response:", res.data);

      // ✅ Get the array of next processes
      const processes = res.data?.next_processes || [];

      console.log(`✅ API returned ${processes.length} processes`);

      if (processes.length === 0) {
        console.log("⚠️ No next process available");
        setNextProcesses({});
        setCurrentProcessId(null);
        return;
      }

      // ✅ ONLY take the FIRST process (ignore the rest)
      const firstProcess = processes[0];
      console.log("✅ Using FIRST process only:", firstProcess);

      // ✅ Create a map with ONLY the first process
      // const processMap = {
      //   [firstProcess.process_id]: {
      //     action: firstProcess.action,
      //     name: firstProcess.name,
      //     status: firstProcess.status,
      //   },
      // };
      const processMap = processes.reduce((acc, p) => {
        acc[p.process_id] = {
          action: p.action,
          name: p.name,
          status: p.status,
        };
        return acc;
      }, {});

      setNextProcesses(processMap);
      setCurrentProcessId(firstProcess.process_id);
    } catch (err) {
      console.error("❌ Failed to fetch next processes:", err);
      setNextProcesses([]);
      setCurrentProcessId(null);
    }
  };

  /* ---------------- MANUAL REFRESH ---------------- */
  const handleRefresh = async () => {
    if (refreshing) return;
    try {
      setRefreshing(true);
      await fetchNextProcesses();
      if (refreshEquipmentDetails) {
        // force: true bypasses the requestKey dedupe guard so the table
        // refetches the latest statuses, dependencies and Δ Duration.
        await refreshEquipmentDetails({ force: true, silent: true });
      }
    } catch (err) {
      console.error("❌ Failed to refresh execution table:", err);
      showNotification("Failed to refresh", "error");
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (equipmentId) {
      fetchNextProcesses();
    }
  }, [equipmentId, isEquipmentOnHold]);

  useEffect(() => {
    if (!realtimeProcessUpdate || !equipmentId) return;

    if (isEquipmentOnHold) {
      setNextProcesses({});
      setCurrentProcessId(null);
      return;
    }

    if (
      String(realtimeProcessUpdate?.equipment_id || "") !== String(equipmentId)
    ) {
      return;
    }

    const processId = String(realtimeProcessUpdate?.process_id || "");
    if (!processId) return;

    const action = String(realtimeProcessUpdate?.action || "")
      .trim()
      .toLowerCase();

    setNextProcesses((prev) => {
      const next = { ...(prev || {}) };

      if (action === "start") {
        next[processId] = {
          ...(next[processId] || {}),
          action: "End",
          status: realtimeProcessUpdate?.status || "In Progress",
        };
      } else if (action === "end" || action === "bypass") {
        delete next[processId];
      }

      return next;
    });
  }, [realtimeProcessUpdate, equipmentId, isEquipmentOnHold]);

  useEffect(() => {
    if (!equipmentId || !realtimeUpdateSignal) return;

    if (realtimeNextProcessTimerRef.current) {
      clearTimeout(realtimeNextProcessTimerRef.current);
    }

    realtimeNextProcessTimerRef.current = setTimeout(() => {
      fetchNextProcesses();
    }, 1000);

    return () => {
      if (realtimeNextProcessTimerRef.current) {
        clearTimeout(realtimeNextProcessTimerRef.current);
      }
    };
  }, [equipmentId, realtimeUpdateSignal]);

  const submitBypass = async () => {
    if (!bypassModal.processId) {
      showNotification("No process selected", "error");
      return;
    }

    try {
      setBypassModal((previous) => ({ ...previous, loading: true }));

      const reason = bypassModal.reason.trim();
      const response = await axiosInstance.post(
        `${API_URL}/api/process/${bypassModal.processId}/bypass`,
        reason ? { reason } : {},
      );
      const bypassedProcess = response?.data || {};

      if (typeof onProcessBypassed === "function") {
        onProcessBypassed({
          ...bypassedProcess,
          process_id: bypassedProcess.process_id ?? bypassModal.processId,
          bypass_reason: (bypassedProcess.bypass_reason ?? reason) || null,
        });
      }

      setOptimisticStepUpdates((previous) => ({
        ...previous,
        [bypassModal.processId]: {
          ...(previous[bypassModal.processId] || {}),
          is_bypassed: true,
          bypassed_by: bypassedProcess.bypassed_by ?? null,
          bypassed_at: bypassedProcess.bypassed_at ?? null,
          bypass_reason: (bypassedProcess.bypass_reason ?? reason) || null,
        },
      }));

      setNextProcesses((previous) => {
        const next = { ...(previous || {}) };
        delete next[bypassModal.processId];
        return next;
      });

      showNotification("Process bypassed successfully", "success");
      closeBypassModal();

      await fetchNextProcesses();
      if (refreshEquipmentDetails) {
        await refreshEquipmentDetails({ force: true, silent: true });
      }
    } catch (err) {
      console.error("Bypass error:", err);

      const responseData = err.response?.data;
      const errorMessage =
        responseData?.error ||
        responseData?.message ||
        (typeof responseData === "string" ? responseData : null) ||
        err.message ||
        "Unable to bypass process";
      showNotification(errorMessage, "error");

      try {
        await fetchNextProcesses();
        if (refreshEquipmentDetails) {
          await refreshEquipmentDetails({ force: true, silent: true });
        }
      } catch (reconcileError) {
        console.error("Bypass reconciliation refresh failed:", reconcileError);
      }

      setBypassModal((previous) => ({ ...previous, loading: false }));
    }
  };

  /* ---------------- START / END PROCESS ---------------- */
  const submitProcessAction = async () => {
    if (isEquipmentOnHold) {
      showNotification(holdActionMessage, "warning");
      closeModal();
      return;
    }

    if (!modal.processId) {
      showNotification("No process selected", "error");
      return;
    }

    try {
      setModal((p) => ({ ...p, loading: true }));

      // ✅ CREATE FormData for file upload
      const formData = new FormData();
      formData.append("action", modal.action);

      // ✅ Add start_time if action is "Start"
      if (modal.action === "Start") {
        // Convert modal.time from "yyyy-MM-ddTHH:mm" to "yyyy-MM-dd HH:mm:ss"
        const startTime = modal.time
          ? `${modal.time.replace("T", " ")}:00` // Add seconds
          : new Date().toISOString().slice(0, 19).replace("T", " ");

        formData.append("start_time", startTime);
        console.log("✅ Start Time:", startTime);
      }

      // ✅ Add end_time if action is "End"
      if (modal.action === "End") {
        // Convert modal.time from "yyyy-MM-ddTHH:mm" to "yyyy-MM-dd HH:mm:ss"
        const endTime = modal.time
          ? `${modal.time.replace("T", " ")}:00` // Add seconds
          : new Date().toISOString().slice(0, 19).replace("T", " ");

        formData.append("end_time", endTime);
        console.log("✅ End Time:", endTime);
      }

      const remark = remarkRef.current?.value || "";
      if (remark) {
        formData.append("remark", remark);
      }

      if (modal.file) {
        formData.append("file", modal.file);
      }

      const isMilestone = Boolean(selectedModalStep?.is_milestone);
      const actionUrl = isMilestone
        ? `${API_URL}/api/milestone/${modal.processId}`
        : `${API_URL}/api/process/${modal.processId}`;

      console.log("🚀 Submitting:", {
        url: actionUrl,
        action: modal.action,
        remark,
        file: modal.file?.name,
      });

      const processResponse = await axiosInstance.post(
        actionUrl,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // Compatibility guard for deployments that represent a hold block as
      // HTTP 200 with `blocked: true`.
      if (processResponse?.data?.blocked) {
        const blockedError = new Error(
          processResponse.data.message || processResponse.data.reason,
        );
        blockedError.response = { status: 409, data: processResponse.data };
        throw blockedError;
      }

      const actionTimeValue = modal.time
        ? `${modal.time}:00`
        : new Date().toISOString().slice(0, 19);
      const currentUserLabel =
        localStorage.getItem("name") ||
        localStorage.getItem("email") ||
        null;

      setOptimisticStepUpdates((prev) => ({
        ...prev,
        [modal.processId]: {
          ...(prev[modal.processId] || {}),
          backendStatus: modal.action === "Start" ? "In Progress" : "Completed",
          actual_start:
            modal.action === "Start"
              ? actionTimeValue
              : prev[modal.processId]?.actual_start ||
                processSteps.find(
                  (step) => String(step?.process_id) === String(modal.processId),
                )?.actual_start ||
                null,
          actual_end: modal.action === "End" ? actionTimeValue : null,
          started_by:
            modal.action === "Start"
              ? currentUserLabel
              : prev[modal.processId]?.started_by ||
                processSteps.find(
                  (step) => String(step?.process_id) === String(modal.processId),
                )?.started_by ||
                null,
          ended_by: modal.action === "End" ? currentUserLabel : null,
        },
      }));

      setNextProcesses((prev) => {
        const next = { ...(prev || {}) };
        if (modal.action === "Start") {
          next[modal.processId] = {
            ...(next[modal.processId] || {}),
            action: "End",
            status: "In Progress",
          };
        } else {
          delete next[modal.processId];
        }
        return next;
      });

      showNotification(
        modal.action === "Start"
          ? `${isMilestone ? "Milestone" : "Process"} started successfully`
          : `${isMilestone ? "Milestone" : "Process"} completed successfully`,
        "success",
      );

      closeModal();

      // ✅ Refresh both
      await fetchNextProcesses();
      if (refreshEquipmentDetails) {
        // force: true bypasses the requestKey dedupe guard so the table
        // refetches the just-updated actual_start/actual_end and Δ Duration.
        await refreshEquipmentDetails({ force: true, silent: true });
      }
    } catch (err) {
      console.error("❌ Submit error:", err);

      // ✅ IMPROVED ERROR HANDLING
      let errorMsg = "Action failed";
      const responseData = err.response?.data;
      const isHoldConflict =
        err.response?.status === 409 ||
        responseData?.error === "EQUIPMENT_ON_HOLD" ||
        responseData?.blocked === true;

      if (isHoldConflict) {
        const serverHoldReason = responseData?.hold_reason;
        errorMsg =
          responseData?.message ||
          serverHoldReason ||
          responseData?.reason ||
          "Equipment is on hold";
        if (
          serverHoldReason &&
          !errorMsg.toLowerCase().includes(serverHoldReason.toLowerCase())
        ) {
          errorMsg = `${errorMsg}: ${serverHoldReason}`;
        }
        setNextProcesses({});
        setCurrentProcessId(null);
      } else if (err.response?.data) {
        // Check if backend sent an error message
        if (err.response.data.error) {
          errorMsg = err.response.data.error;
        } else if (err.response.data.message) {
          errorMsg = err.response.data.message;
        } else if (typeof err.response.data === "string") {
          errorMsg = err.response.data;
        }
      } else if (err.message) {
        errorMsg = err.message;
      }

      console.error("📛 Error Message:", errorMsg);
      showNotification(errorMsg, "error");

      // Reconcile UI with server truth. The start/end may have actually applied
      // even though the request surfaced an error (e.g. a transient post-save
      // hiccup), so refetch instead of leaving the table on a stale state — this
      // prevents a confusing "already started" retry. Best-effort; never throws.
      try {
        await fetchNextProcesses();
        if (refreshEquipmentDetails) {
          await refreshEquipmentDetails({ force: true, silent: true });
        }
      } catch (reconcileErr) {
        console.error("Reconcile refresh failed:", reconcileErr);
      }

      if (isHoldConflict) {
        setModal({
          open: false,
          action: null,
          processId: null,
          processName: "",
          file: null,
          time: "",
          loading: false,
        });
      } else {
        setModal((p) => ({ ...p, loading: false }));
      }
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";

    try {
      // Backend already converts to IST, just format the date string
      const dateObj = new Date(date);

      if (isNaN(dateObj.getTime())) {
        return "N/A";
      }

      return dateObj.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      console.error("Error formatting date:", date, error);
      return "N/A";
    }
  };

  // Same display style as formatDate, but renders in the project's timezone
  // instead of the viewer's browser timezone. Backend sends tz-aware ISO
  // strings (e.g. "...+03:00"); without an explicit timeZone, toLocaleString
  // would re-localize them to the browser zone (e.g. IST). Used for the
  // planned/actual start/end columns. File uploads still use formatDate.
  const formatDateInProjectTz = (date) => {
    if (!date) return "N/A";
    try {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) return "N/A";

      const opts = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };
      if (equipmentTimezone) opts.timeZone = equipmentTimezone;

      return dateObj.toLocaleString("en-IN", opts);
    } catch (error) {
      console.error("Error formatting date:", date, error);
      return "N/A";
    }
  };

  const formatHours = (n) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return "—";
    return Number.isInteger(num) ? `${num}` : num.toFixed(1);
  };

  const formatSignedDiff = (diff) => {
    const num = Number(diff);
    if (!Number.isFinite(num)) return "—";
    const formatted = formatHours(num);
    return num > 0 ? `+${formatted}` : formatted;
  };

  const getDiffClass = (diff) => {
    const num = Number(diff);
    if (!Number.isFinite(num)) return "text-gray-500";
    if (num < 0) return "text-green-600 font-semibold";
    if (num > 0) return "text-red-600 font-semibold";
    return "text-gray-500";
  };

  const fetchFileBlob = async (filePath) => {
    const cleanPath = filePath.replace(/^\/+/, "");

    const response = await axiosInstance.get(
      `${API_URL}/view_image/${cleanPath}`,
      {
        responseType: "blob", // 🔴 IMPORTANT
      },
    );

    return URL.createObjectURL(response.data);
  };

  /* ---------------- RENDER ---------------- */
  return (
    <div className="execution-card">
      <div className="execution-card-header">
        <h3 className="card-title">Equipment Execution Control</h3>
        <div className="execution-header-actions">
          <StyledTooltip title="Refresh" placement="top" arrow>
            <span>
              <button
                type="button"
                className="execution-table-refresh"
                onClick={handleRefresh}
                disabled={refreshing}
                aria-label="Refresh table"
              >
                <FiRefreshCw
                  className={
                    refreshing ? "execution-refresh-icon spinning" : "execution-refresh-icon"
                  }
                />
              </button>
            </span>
          </StyledTooltip>
          <div className="execution-table-search">
          <FiSearch className="execution-table-search-icon" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder="Search process, code, status, dependency..."
            className="execution-table-search-input"
          />
          {searchQuery ? (
            <button
              type="button"
              className="execution-table-search-clear"
              onClick={() => onClearSearch?.()}
              aria-label="Clear search"
            >
              <CloseIcon fontSize="small" />
            </button>
          ) : null}
          </div>
        </div>
      </div>

      <div className="execution-table-wrapper">
        <table className="execution-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Step Name</th>
              <th>Duration</th>
              <th>Δ Duration</th>
              <th>Dependency</th>
              <th>Department</th>
              <th>Status</th>
              <th>Started By</th>
              <th>Ended By</th>
              <th>Actions</th>
              <th>Files</th>
              <th
                onClick={toggleProcessCodeSort}
                title="Sort by process code"
                style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
              >
                Process code{" "}
                <span style={{ opacity: processCodeSort ? 1 : 0.4 }}>
                  {processCodeSort === "asc"
                    ? "▲"
                    : processCodeSort === "desc"
                      ? "▼"
                      : "⇅"}
                </span>
              </th>
              <th>Planned Start</th>
              <th>Planned End</th>
              <th>Actual Start</th>
              <th>Actual End</th>
            </tr>
          </thead>

          <tbody>
            {tableLoading ? (
              <tr>
                <td colSpan={16} className="execution-table-state-cell">
                  <div className="execution-table-inline-loading">
                    <div className="execution-table-inline-spinner" />
                    <span>Searching processes...</span>
                  </div>
                </td>
              </tr>
            ) : steps.length === 0 ? (
              <tr>
                <td colSpan={16} className="execution-table-state-cell">
                  <div className="execution-table-empty-state">
                    <strong>No process found</strong>
                    <span>
                      Try searching by process name, process code, status, or
                      dependency.
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
            displayedSteps.map((step) => {
              // ✅ Check if this process is in the nextProcesses map
              const nextProcess = nextProcesses[step.id];
              const isNextProcess = !!nextProcess;

              // ✅ Button enable logic
              const canStart =
                !isEquipmentOnHold &&
                isNextProcess &&
                nextProcess?.action === "Start" &&
                (!step.is_milestone || isAdmin);
              const startDisabledTitle = isEquipmentOnHold
                ? holdActionMessage
                : step.is_milestone && !isAdmin
                  ? "Only an admin can start or end a milestone"
                  : undefined;
              const canEnd =
                !isEquipmentOnHold &&
                isNextProcess &&
                nextProcess?.action === "End" &&
                (!step.is_milestone || isAdmin);
              const endDisabledTitle = isEquipmentOnHold
                ? holdActionMessage
                : step.is_milestone && !isAdmin
                  ? "Only an admin can start or end a milestone"
                  : undefined;

              // ✅ Status determination
              let status = "Blocked";
              let statusClass = "blocked";

              if (step.is_bypassed) {
                status = "Bypassed";
                statusClass = "bypassed";
              } else if (step.backendStatus === "Completed") {
                status = "Completed";
                statusClass = "completed";
              } else if (isNextProcess) {
                if (nextProcess?.action === "Start") {
                  status = "Not Started";
                  statusClass = "not-started";
                } else if (nextProcess?.action === "End") {
                  status = "In Progress";
                  statusClass = "in-progress";
                }
              }

              // ✅ Dependency display with lag
              let dependencyText = "No dependencies";
              if (step.predecessorCount > 0) {
                dependencyText = `${
                  step.relation
                } on Step ${step.predecessorStepNos.join(", ")}`;

                // Add lag information if available
                // if (step.lagInfo) {
                //   const unitText =
                //     {
                //       D: "days",
                //       H: "hours",
                //       W: "weeks",
                //       M: "months",
                //     }[step.lagInfo.unit] || step.lagInfo.unit;

                //   dependencyText += ` + ${step.lagInfo.lag} ${unitText}`;
                // }
              }

              const isSelectedFromFlowchart =
                String(step.id) === String(selectedProcessId);
              const isDependencyFocused =
                String(step.id) === String(dependencyHighlightedProcessId);
              const da = step.duration_analysis;
              const diff = da?.duration_difference;
              const varianceText =
                da?.percent_variance == null ? "NA" : `${da.percent_variance}%`;
              const durationTooltip = da ? (
                <div style={{ fontSize: "12px", whiteSpace: "pre-line" }}>
                  <div>Planned: {formatHours(da.planned_duration)}h</div>
                  <div>Actual: {formatHours(da.actual_duration)}h</div>
                  <div>Difference: {formatSignedDiff(diff)}h</div>
                  <div>Variance: {varianceText}</div>
                  <div>Status: {da.status || "NA"}</div>
                </div>
              ) : (
                ""
              );

              return (
                <tr
                  key={step.id}
                   data-process-id={step.id}
                  style={{
                    transition: "background-color 0.3s ease",
                    ...(isSelectedFromFlowchart
                      ? {
                            backgroundColor: "#fdf0ef",
                            fontWeight: 600,
                            borderLeft: "4px solid #b71c1c",
                            boxShadow: "inset 0 0 0 1px rgba(183, 28, 28, 0.15)",
                            transition: "all 0.2s ease-in-out",
                            cursor: "pointer"

                        }
                      : isDependencyFocused
                        ? {
                            backgroundColor: "#fdf0ef",
                            borderLeft: "4px solid #b71c1c",
                            boxShadow:
                              "inset 0 0 0 1px rgba(183, 28, 28, 0.15)",
                            transition: "all 0.2s ease-in-out",
                          }
                        : {}),
                  }}
                >
                  <td>{step.stepNo}</td>
                  <td className="truncate" title={step.name}>
                    {step.name}
                    {/* {step.is_milestone && (
                      <span className="milestone-badge">M</span>
                    )} */}
                  </td>
                  <td>{step.duration}</td>
                  <td>
                    {diff == null ? (
                      "—"
                    ) : (
                      <StyledTooltip title={durationTooltip} placement="top" arrow>
                        <span className={getDiffClass(diff)}>
                          {formatSignedDiff(diff)}h
                        </span>
                      </StyledTooltip>
                    )}
                  </td>
                  <td className="dependency">
                    <div style={{ fontSize: "12px" }}>
                      {processSteps.find((s) => s.process_id === step.id)
                        ?.dependencies?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          {processSteps
                            .find((s) => s.process_id === step.id)
                            .dependencies.map((dep, idx) => {
                              // Build the encoded format: 244FS+14D
                              let encodedText = dep.depends_on.code; // Start with code
                              if (dep.relation) {
                                encodedText += dep.relation; // Add relation (FS)
                              }
                              if (dep.lag && dep.unit) {
                                encodedText += `+${dep.lag}${dep.unit}`; // Add lag (+14D)
                              }

                              return (
                                <span key={idx}>
                                  <StyledTooltip
                                    title={
                                      <div style={{ fontSize: "12px" }}>
                                        <div>
                                          <strong>Name:</strong>{" "}
                                          {dep.depends_on.name}
                                        </div>
                                        <div>
                                          <strong>Code:</strong>{" "}
                                          {dep.depends_on.code}
                                        </div>
                                        <div>
                                          <strong>Relation:</strong>{" "}
                                          {dep.relation}
                                        </div>
                                        {dep.lag && (
                                          <div>
                                            <strong>Lag:</strong> {dep.lag}{" "}
                                            {dep.unit}
                                          </div>
                                        )}
                                      </div>
                                    }
                                    placement="top"
                                    arrow
                                  >
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        cursor: "pointer",
                                        color: "#9f1919",
                                        fontWeight: "600",
                                        textDecoration: "underline",
                                        textDecorationStyle: "dotted",
                                        textDecorationColor: "#c67c7c",
                                      }}
                                      onClick={() =>
                                        handleDependencyRedirect(dep)
                                      }
                                    >
                                      <span>{encodedText}</span>
                                      <OpenInNewIcon sx={{ fontSize: 13 }} />
                                    </span>
                                  </StyledTooltip>
                                  {idx <
                                    processSteps.find(
                                      (s) => s.process_id === step.id,
                                    ).dependencies.length -
                                      1 && (
                                    <span style={{ marginRight: "4px" }}>
                                      ,
                                    </span>
                                  )}
                                </span>
                              );
                            })}
                        </div>
                      ) : (
                        <span>No dependencies</span>
                      )}
                    </div>
                  </td>
                  <td className="department-cell">
                    {step.departments.length > 0
                      ? step.departments
                          .map((department) => department?.department_name)
                          .filter(Boolean)
                          .join(", ") || "-"
                      : "-"}
                  </td>
                  <td>
                    {status === "Blocked" && step.blocked_reason ? (
                      renderStatusBadge(status, statusClass, {
                        style: { cursor: "pointer" },
                      })
                    ) : status === "Bypassed" ? (
                      <StyledTooltip
                        title={
                          <div>
                            <div>Dependency release recorded; normal execution remains available.</div>
                            {step.bypassed_at && (
                              <div>
                                Bypassed at: {formatDateInProjectTz(step.bypassed_at)}
                              </div>
                            )}
                            {(step.bypassed_by_name || step.bypassed_by) && (
                              <div>
                                Bypassed by: {step.bypassed_by_name || step.bypassed_by}
                              </div>
                            )}
                            {step.bypass_reason && (
                              <div>Reason: {step.bypass_reason}</div>
                            )}
                          </div>
                        }
                        placement="top"
                        arrow
                      >
                        {renderStatusBadge(status, statusClass, {
                          style: { cursor: "pointer" },
                        })}
                      </StyledTooltip>
                    ) : status === "Completed" || status === "In Progress" ? (
                      <StyledTooltip
                        title={
                          <div>
                            {step.started_by && (
                              <div>Started by: {step.started_by}</div>
                            )}
                            {step.start_remark && (
                              <div>Start remark: {step.start_remark}</div>
                            )}
                            {step.ended_by && (
                              <div>Ended by: {step.ended_by}</div>
                            )}
                            {step.end_remark && (
                              <div>End remark: {step.end_remark}</div>
                            )}
                          </div>
                        }
                        placement="top"
                        arrow
                      >
                        {renderStatusBadge(status, statusClass, {
                          style: { cursor: "pointer" },
                        })}
                      </StyledTooltip>
                    ) : (
                      renderStatusBadge(status, statusClass)
                    )}
                  </td>
                  <td>
                    {step.start_remark ? (
                      <StyledTooltip
                        title={`Start remark: ${step.start_remark}`}
                        placement="top"
                        arrow
                      >
                        <span className="remark-cell" style={{ cursor: "pointer" }}>
                          {step.started_by || "N/A"}
                          <ChatBubbleOutlineIcon
                            className="remark-indicator"
                            aria-hidden="true"
                          />
                        </span>
                      </StyledTooltip>
                    ) : (
                      step.started_by || "N/A"
                    )}
                  </td>
                  <td>
                    {step.end_remark ? (
                      <StyledTooltip
                        title={`End remark: ${step.end_remark}`}
                        placement="top"
                        arrow
                      >
                        <span className="remark-cell" style={{ cursor: "pointer" }}>
                          {step.ended_by || "N/A"}
                          <ChatBubbleOutlineIcon
                            className="remark-indicator"
                            aria-hidden="true"
                          />
                        </span>
                      </StyledTooltip>
                    ) : (
                      step.ended_by || "N/A"
                    )}
                  </td>
                  <td>
                    <div className="actions">
                      {(!step.is_milestone || isAdmin) && (
                        <>
                      {status === "Blocked" && step.blocked_reason ? (
                        <StyledTooltip
                          title={step.blocked_reason}
                          placement="top"
                          arrow
                        >
                          <span>
                            <button
                              disabled={!canStart}
                              title={startDisabledTitle}
                              onClick={() =>
                                openModal(step.id, step.name, "Start")
                              }
                              style={
                                canStart
                                  ? {
                                      background: "#4caf50",
                                      color: "white",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }
                                  : {}
                              }
                            >
                              <FaPlay /> Start
                            </button>
                          </span>
                        </StyledTooltip>
                      ) : status === "Completed" && step.blocked_reason ? (
                        <StyledTooltip
                          title={step.blocked_reason}
                          placement="top"
                          arrow
                        >
                          <span>
                            <button
                              disabled={!canStart}
                              title={startDisabledTitle}
                              onClick={() =>
                                openModal(step.id, step.name, "Start")
                              }
                              style={
                                canStart
                                  ? {
                                      background: "#4caf50",
                                      color: "white",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }
                                  : {}
                              }
                            >
                              <FaPlay /> Start
                            </button>
                          </span>
                        </StyledTooltip>
                      ) : (
                        <button
                          disabled={!canStart}
                          title={startDisabledTitle}
                          onClick={() => openModal(step.id, step.name, "Start")}
                          style={
                            canStart
                              ? {
                                  background: "#4caf50",
                                  color: "white",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                }
                              : {}
                          }
                        >
                          <FaPlay /> Start
                        </button>
                      )}

                      {status === "Completed" && step.blocked_reason ? (
                        <StyledTooltip
                          title={step.blocked_reason}
                          placement="top"
                          arrow
                        >
                          <span>
                            <button
                              disabled={!canEnd}
                              title={endDisabledTitle}
                              onClick={() =>
                                openModal(step.id, step.name, "End")
                              }
                              style={
                                canEnd
                                  ? {
                                      background: "#f44336",
                                      color: "white",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }
                                  : {}
                              }
                            >
                              <FaSquare /> End
                            </button>
                          </span>
                        </StyledTooltip>
                      ) : (
                        <button
                          disabled={!canEnd}
                          title={endDisabledTitle}
                          onClick={() => openModal(step.id, step.name, "End")}
                          style={
                            canEnd
                              ? {
                                  background: "#f44336",
                                  color: "white",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                }
                              : {}
                          }
                        >
                          <FaSquare /> End
                        </button>
                      )}
                        </>
                      )}
                      {canBypassProcess(step) && (
                        <button
                          type="button"
                          className="bypass-process-action"
                          onClick={() => openBypassModal(step)}
                        >
                          <BiErrorCircle /> Bypass
                        </button>
                      )}
                      {isAdmin && (
                        <StyledTooltip
                          title={step.admin_notes.length ? "View admin note" : "Add admin note"}
                          placement="top"
                          arrow
                        >
                          <button
                            type="button"
                            className={`admin-note-action${step.admin_notes.length ? " has-note" : ""}`}
                            aria-label={step.admin_notes.length ? "View admin note" : "Add admin note"}
                            onClick={() => {
                              closeModal();
                              setAdminNoteModal({
                                open: true,
                                remark: "",
                                processId: step.id,
                                loading: false,
                                notes: step.admin_notes,
                              });
                            }}
                          >
                            <LiaUserEditSolid aria-hidden="true" />
                            {step.admin_notes.length > 0 && (
                              <span className="admin-note-presence-dot" aria-hidden="true" />
                            )}
                          </button>
                        </StyledTooltip>
                      )}
                     
                    </div>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {step.files.length > 0 ? (
                      <button
                        onClick={async () => {
                          // Separate start and end files
                          const startFile = step.files.find(
                            (f) => f.stage === "start",
                          );
                          const endFile = step.files.find(
                            (f) => f.stage === "end",
                          );

                          // Fetch preview URLs
                          const startUrl = startFile
                            ? await fetchFileBlob(startFile.file_path)
                            : null;
                          const endUrl = endFile
                            ? await fetchFileBlob(endFile.file_path)
                            : null;

                          setFilePreview({
                            open: true,
                            stepName: step.name,
                            stepCode: step.process_code,
                            startFile: startFile || null,
                            endFile: endFile || null,
                            startPreviewUrl: startUrl,
                            endPreviewUrl: endUrl,
                            started_by: step.started_by,
                            ended_by: step.ended_by,
                          });
                        }}
                        style={{
                          background: "none",
                          border: "1px solid #dc2626",
                          borderRadius: "4px",
                          padding: "6px 12px",
                          cursor: "pointer",
                          color: "#dc2626",
                          fontSize: "14px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <IoIosEye size={16} />
                        View
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>{step.process_code}</td>
                  <td>{formatDateInProjectTz(step.planned_start)}</td>
                  <td>{formatDateInProjectTz(step.planned_end)}</td>
                  <td>{formatDateInProjectTz(step.actual_start)}</td>
                  <td>{formatDateInProjectTz(step.actual_end)}</td>
                </tr>
              );
            }))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      <Modal open={modal.open} onClose={closeModal}>
        <Box sx={processActionModalStyle} className="process-action-modal">
          <div className="process-action-modal-header modern">
            <div className="process-action-accent" />
            <div className="process-action-header-main">
              <div className="process-action-title-row">
                <div className="process-action-title-left">
                  <IoPlayCircleOutline className="process-action-title-icon" />
                  <Typography variant="h6" className="process-action-modal-title">
                    {modal.action === "Start" ? "Start Process" : `${modal.action} Process`}
                  </Typography>
                </div>
                <IconButton
                  size="small"
                  onClick={closeModal}
                  disabled={modal.loading}
                  className="process-action-close-btn"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
              <Typography className="process-action-process-name">
                {modal.processName || "N/A"}
              </Typography>
            </div>
          </div>

          <div className="process-action-header-divider" />

          <div className="process-action-timezone-row">
            <LuGlobe className="process-action-timezone-icon" />
            <span className="process-action-timezone-label">Timezone</span>
            <span className="process-action-timezone-value">{timezoneDisplay}</span>
          </div>

          <Box sx={{ mb: 1.8 }}>
            {modal.action === "End" && (
              <Box sx={{ mb: 1.2 }}>
                <Typography className="process-action-field-label">Started at</Typography>
                <TextField
                  fullWidth
                  value={startedAtDisplay || "N/A"}
                  InputProps={{ readOnly: true }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      backgroundColor: "#f9fafb",
                      minHeight: 48,
                      "& fieldset": { borderColor: "#e5e7eb" },
                    },
                    "& .MuiInputBase-input": {
                      color: "#374151",
                      fontWeight: 500,
                    },
                  }}
                />
              </Box>
            )}
            <Box>
              <Typography className="process-action-field-label">
                {modal.action === "Start" ? "Start Time" : "End Time"}
              </Typography>
              {canEditProcessTime ? (
                <DatePicker
                  selected={parseDateTimeLocalValue(modal.time)}
                  onChange={(date) =>
                    setModal((p) => ({
                      ...p,
                      time: date ? formatToDateTimeLocalValue(date) : "",
                    }))
                  }
                  showTimeSelect
                  timeIntervals={5}
                  timeFormat="HH:mm"
                  dateFormat="yyyy-MM-dd HH:mm"
                  placeholderText="Select date and time"
                  className="process-action-datetime-input"
                  popperClassName="process-action-datepicker-popper"
                  calendarClassName="process-action-datepicker-calendar"
                  portalId="root"
                  required
                />
              ) : (
                <div
                  className="process-action-readonly-time"
                  aria-label={`${modal.action === "Start" ? "Start" : "End"} time`}
                >
                  {formatDateTimeFromParts(parseDateTimeParts(modal.time)) || "N/A"}
                </div>
              )}
            </Box>

            {modal.action === "Start" && (
              <Box
                className="process-action-summary-card"
              >
                <div className="process-action-summary-item">
                  <span className="process-action-summary-label">
                    <FiClock className="process-action-summary-icon" />
                    Duration
                  </span>
                  <span className="process-action-summary-value">
                    {durationDisplay || "N/A"}
                  </span>
                </div>
                <div className="process-action-summary-divider" />
                <div className="process-action-summary-item">
                  <span className="process-action-summary-label">Tentative End</span>
                  <span className="process-action-summary-value end">
                    {tentativeEndTimeDisplay || "N/A"}
                  </span>
                </div>
              </Box>
            )}
          </Box>

          <TextField
            key={modal.processId + modal.action}
            fullWidth
            multiline
            rows={4}
            label="Remark (Optional)"
            placeholder="Enter any notes or comments..."
            defaultValue=""
            inputRef={remarkRef}
            sx={processActionTextAreaSx}
          />

          {/* ✅ ADD FILE UPLOAD */}
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={processActionUploadButtonSx}
          >
            <IoMdAttach style={{ fontSize: 18, marginRight: 8 }} />
            {modal.file ? modal.file.name : "Attach file (optional)"}
            <input
              type="file"
              hidden
              onChange={(e) =>
                setModal((p) => ({ ...p, file: e.target.files[0] }))
              }
            />
          </Button>

          {showSlowSubmissionNotice && (
            <Box
              role="status"
              aria-live="polite"
              sx={{
                mt: 1.5,
                px: 2,
                py: 1.25,
                borderRadius: "10px",
                border: "1px solid #f1d39a",
                backgroundColor: "#fff8e8",
                color: "#8a4b08",
                fontSize: "0.9rem",
                lineHeight: 1.45,
              }}
            >
              Completing the action and notifying assigned users. This can take
              a little longer when several devices are registered. Please keep
              this window open.
            </Box>
          )}

          <Box className="process-action-modal-footer">
            <Button
              onClick={closeModal}
              disabled={modal.loading}
              className="process-action-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submitProcessAction}
              disabled={modal.loading || isEquipmentOnHold}
              title={isEquipmentOnHold ? holdActionMessage : undefined}
              className="process-action-submit-btn"
            >
              {modal.loading
                ? showSlowSubmissionNotice
                  ? "Notifying users..."
                  : "Submitting..."
                : modal.action === "Start"
                  ? "Start Process"
                  : "End Process"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={bypassModal.open} onClose={closeBypassModal}>
        <Box
          sx={{
            ...processActionModalStyle,
            border: "1px solid #fecaca",
            boxShadow: "0 18px 50px rgba(127, 29, 29, 0.2)",
          }}
        >
          <div className="process-action-modal-header modern">
            <div className="process-action-accent" />
            <div className="process-action-header-main">
              <div className="process-action-title-row">
                <div className="process-action-title-left">
                  <BiErrorCircle className="process-action-title-icon" />
                  <Typography variant="h6" className="process-action-modal-title">
                    Bypass Process
                  </Typography>
                </div>
                <IconButton
                  size="small"
                  onClick={closeBypassModal}
                  disabled={bypassModal.loading}
                  className="process-action-close-btn"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
              <Typography className="process-action-process-name">
                {bypassModal.processName || "N/A"}
              </Typography>
            </div>
          </div>

          <div className="process-action-header-divider" />

          <Alert severity="warning" sx={{ mt: 2, mb: 2, alignItems: "center" }}>
            This releases downstream dependencies only. You can continue this
            process through its normal Start and End actions.
          </Alert>

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Reason (Optional)"
            placeholder="Explain why this process is being bypassed..."
            value={bypassModal.reason}
            inputProps={{ maxLength: 255 }}
            onChange={(event) =>
              setBypassModal((previous) => ({
                ...previous,
                reason: event.target.value,
              }))
            }
            sx={processActionTextAreaSx}
          />

          <Box className="process-action-modal-footer">
            <Button
              onClick={closeBypassModal}
              disabled={bypassModal.loading}
              className="process-action-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submitBypass}
              disabled={bypassModal.loading}
              sx={{
                background: "#991b1b",
                "&:hover": { background: "#7f1d1d" },
              }}
            >
              {bypassModal.loading ? "Bypassing..." : "Bypass Process"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={adminNoteModal.open} onClose={closeAdminNoteModal}>
        <Box sx={adminNoteModalStyle}>
          <div className="process-action-modal-header modern">
            <div className="process-action-header-main">
              <div className="process-action-title-row">
                <div className="process-action-title-left">
                  <LiaUserEditSolid className="process-action-title-icon" />
                  <Typography variant="h6" className="process-action-modal-title">
                    Admin Note
                  </Typography>
                </div>
                <IconButton
                  size="small"
                  onClick={closeAdminNoteModal}
                  disabled={adminNoteModal.loading}
                  className="process-action-close-btn"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
          </div>

          <div className="process-action-header-divider" />

          

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Remark"
            placeholder="Type your note here..."
            value={adminNoteModal.remark}
            onChange={(e) =>
              setAdminNoteModal((p) => ({
                ...p,
                remark: e.target.value,
              }))
            }
            sx={adminNoteInputSx}
          />

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1.2}>
            <Button
              variant="outlined"
              sx={{
                width: "50%",
                borderColor: "#d7aaaa",
                color: "#8f2d2d",
                borderRadius: "10px",
                py: 1.2,
                fontWeight: 600,
                textTransform: "none",
                "&:hover": { borderColor: "#bf4b4b", backgroundColor: "#fff7f7" },
              }}
              onClick={closeAdminNoteModal}
              disabled={adminNoteModal.loading}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              sx={{
                width: "50%",
                borderRadius: "10px",
                py: 1.2,
                fontWeight: 700,
                textTransform: "none",
                background: "linear-gradient(90deg, #b91c1c 0%, #dc2626 100%)",
                boxShadow: "0 6px 16px rgba(185, 28, 28, 0.25)",
                "&:hover": {
                  background: "linear-gradient(90deg, #a41616 0%, #c81e1e 100%)",
                },
              }}
              onClick={submitAdminNote}
              disabled={adminNoteModal.loading}
            >
              {adminNoteModal.loading ? "Submitting..." : "Submit"}
            </Button>
          </Box>

          <Box mt={2.2}>
            <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#1f2937", mb: 1 }}>
              Previous Notes
            </Typography>

            <Box
              sx={{
                maxHeight: "170px",
                overflowY: "auto",
                background: "#fff9f9",
                borderRadius: "10px",
                border: "1px solid #f0dede",
                p: 1,
              }}
            >
              {adminNoteModal.notes?.length ? (
                adminNoteModal.notes.map((note, index) => (
                  <Box
                    key={index}
                    sx={{
                      p: 1,
                      borderBottom: index !== adminNoteModal.notes.length - 1 ? "1px solid #f0dede" : "none",
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#374151" }}>
                      {note.content}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" sx={{ color: "#6b7280", p: 1 }}>
                  No admin notes yet
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
      <FilePreviewModal
        preview={filePreview}
        formatUploadedAt={formatDate}
        onClose={() => {
          [filePreview.startPreviewUrl, filePreview.endPreviewUrl].forEach((url) => {
            if (url) URL.revokeObjectURL(url);
          });
          setFilePreview({
            open: false,
            stepName: "",
            stepCode: "",
            startFile: null,
            endFile: null,
            startPreviewUrl: null,
            endPreviewUrl: null,
            started_by: null,
            ended_by: null,
          });
        }}
      />

      {/* NOTIFICATION */}
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={notification.severity}
          onClose={() => setNotification((p) => ({ ...p, open: false }))}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default EquipmentExecutionTable;
